/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

// If you change this, you might also want to change OKTA_ISSUER below as well
export const PEARL_API_URL = process.env.REACT_APP_PEARL_API_URL || 'https://api.dev.medpearl.com/api/v1';
export const PEARL_API_BASE_URL = PEARL_API_URL.replace('/api/v1', '');
export const NO_SERVER = PEARL_API_URL.startsWith('/');
//export const PEARL_API_URL = process.env.REACT_APP_PEARL_API_URL || 'https://teg-ckh-docs-temp.pearl-project.io/api/v1';
// To Launch against test in local, use this:
// REACT_APP_PEARL_API_URL=https://api.test.medpearl.com/api/v1 npm start

export const AZURE_STORAGE_ACCOUNT = process.env.REACT_APP_AZURE_STORAGE_ACCOUNT || 'stmedpearldev';

export const OKTA_ISSUER = process.env.REACT_APP_OKTA_ISSUER || 'https://login-test.medpearl.com/oauth2/default';
// export const OKTA_ISSUER = process.env.REACT_APP_OKTA_ISSUER || 'https://tegria-cust.okta.com/oauth2/default';

export const PEARL_PUBLIC_URL = '';
// export const PEARL_PUBLIC_URL = 'https://dev.medpearl.com';

// IMPORTANT: Please use the prefix 'REACT_APP_' for all environment variables that need to be exposed to the client otherwise it might not work. ;)
